import { Link } from "react-router-dom";

const highlights = [
  { icon: "ri-school-line", text: "現地アイルランドの高校に正式入学" },
  { icon: "ri-global-line", text: "欧州で本場の英語に毎日どっぷり浸れる" },
  { icon: "ri-group-line", text: "世界中の高校生と友人になれる" },
  { icon: "ri-graduation-cap-line", text: "帰国後の大学進学・就活でアピールできる" },
];

export default function HighSchoolPreviewSection() {
  return (
    <section id="highschool" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">High School</span>
          <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            🎒 アイルランドで高校留学 🎒
          </h2>
          <p className="text-gray-500 mt-3 text-sm max-w-xl mx-auto">
            アイルランドには充実した高校留学プログラムがあります。
            若いうちに海外で学ぶ貴重な経験を、ClassLive留学がサポートします。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="w-full h-72 rounded-lg overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/3b702202-0318-4c31-a799-e1275b89fa8c_shutterstock_2284567243.jpg?v=9ff56c387bec024aafe49406a056c242"
                alt="アイルランド高校留学"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div>
            <div className="space-y-3 mb-7">
              {highlights.map((h, i) => (
                <div key={i} className="flex items-center gap-3 bg-emerald-50 rounded-lg px-4 py-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600 flex-shrink-0">
                    <i className={`${h.icon}`} />
                  </span>
                  <span className="text-sm font-medium text-gray-700">{h.text}</span>
                </div>
              ))}
            </div>

            <div className="bg-gray-50 rounded-lg p-5 border border-gray-100 mb-6">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-xs text-gray-500 mb-1">対象年齢</div>
                  <div className="text-sm font-semibold text-gray-800">15〜18歳</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">留学期間</div>
                  <div className="text-sm font-semibold text-gray-800">1年〜　*要相談</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">入学時期</div>
                  <div className="text-sm font-semibold text-gray-800">9月（秋学期）</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">滞在形式</div>
                  <div className="text-sm font-semibold text-gray-800">ホームステイ / 学生寮</div>
                </div>
              </div>
            </div>

            <Link
              to="/high-school"
              className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-bold px-7 py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              高校留学の詳細を見る
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
